"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createZodSchemaValidator = exports.customZodError = exports.labelZodErrors = exports.createAppLinkedValidator = void 0;
const _1 = require("./");
const createAppLinkedValidator = (appId) => new _1.Validator(`AppLinked[id=${appId}]`, async (_value, context) => {
    const { name, isLinked } = await context.getAppAuthInfo(appId);
    if (!isLinked) {
        return [
            {
                errorCode: "MISSING_APP_AUTH",
                path: ["appAuth", appId, "isLinked"],
                message: `${name} link is required.`,
            },
        ];
    }
    return [];
});
exports.createAppLinkedValidator = createAppLinkedValidator;
const labelZodErrors = (label) => {
    return {
        description: label,
        invalid_type_error: `${label} is required.`,
        required_error: `${label} is required.`,
    };
};
exports.labelZodErrors = labelZodErrors;
const customZodError = (message) => {
    return {
        description: message,
        invalid_type_error: message,
        required_error: message,
    };
};
exports.customZodError = customZodError;
const createZodSchemaValidator = (pathToValue, schema) => new _1.Validator(`ZodSchema[field=/${pathToValue.join("/")}]`, async (value) => {
    let scopedValue = value;
    for (const pathPart of pathToValue) {
        // @ts-expect-error types are tough here and do not provide much value.
        // The resulting `scopedValue` is only passed to Zod for validation anyway.
        scopedValue = scopedValue?.[pathPart];
    }
    const result = await schema.safeParseAsync(scopedValue);
    if (result.success) {
        return [];
    }
    return result.error.issues.map((issue) => {
        return {
            errorCode: issue.code,
            path: [...pathToValue, ...issue.path],
            message: issue.message,
        };
    });
});
exports.createZodSchemaValidator = createZodSchemaValidator;
//# sourceMappingURL=SharedValidators.js.map